export const uk = {
    billion: 'млрд',
    million: 'млн',
    quadrillion: 'квадрлн',
    quintillion: 'квинтлн',
    thousand: 'тыс.',
    trillion: 'трлн'
};
